<template>
  <div>
    <h1>Sitzung</h1>

    <p>
      <c-button-link
        icon="el-icon-back"
        round
        :to="{
          name: 'coaching-detail',
          params: { id: session.coaching }
        }"
      >
        Zurück zum Coaching
      </c-button-link>

      <el-button
        v-if="showAcceptReject"
        :loading="acceptStatus === $config.status.LOADING"
        round
        type="success"
        @click="accept"
      >
        Einladung annehmen
      </el-button>

      <el-button
        v-if="showAcceptReject"
        :loading="rejectStatus === $config.status.LOADING"
        round
        type="danger"
        @click="reject"
      >
        Einladung ablehnen
      </el-button>
    </p>

    <div v-if="sessionStatus === $config.status.SUCCESS">
      <el-card v-if="session.alert.title">
        <el-alert
          :closable="false"
          show-icon
          :title="session.alert.title"
          :type="session.alert.type"
        />
      </el-card>

      <el-row :gutter="32">
        <el-col
          :sm="8"
          :md="6"
        >
          <p>
            <small>Datum</small><br>
            {{ session.date | formatDate }}
          </p>
        </el-col>

        <el-col
          :sm="16"
          :md="9"
        >
          <p>
            <small>Zeitraum</small><br>
            {{ session.timeStart | formatDate('time') }} Uhr – {{ session.timeEnd | formatDate('time') }} Uhr
          </p>
        </el-col>

        <el-col
          v-if="session.location"
          :md="9"
        >
          <p>
            <small>Ort</small><br>
            {{ session.location }}
          </p>
        </el-col>
      </el-row>

      <p v-if="session.comment">
        <small>Kommentar</small><br>
        {{ session.comment }}
      </p>
    </div>
  </div>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'
import formatDate from '@/functions/formatDate'
import LoadingOverlay from '@/functions/LoadingOverlay'

export default {
  name: 'VSessionDetail',

  metaInfo: {
    title: 'Sitzung'
  },

  filters: {
    formatDate
  },

  components: {
    CButtonLink
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      sessionStatus: this.$config.status.IDLE,
      acceptStatus: this.$config.status.IDLE,
      rejectStatus: this.$config.status.IDLE,
      session: {}
    }
  },

  computed: {
    showAcceptReject () {
      return (
        this.$is([this.$config.groups.COACH]) &&
        this.session.status === this.$config.sessionStatus.COACHEE_ACCEPTED
      ) || (
        this.$is([this.$config.groups.COACHEE]) &&
        this.session.status === this.$config.sessionStatus.COACH_ACCEPTED
      )
    }
  },

  created () {
    this.getSession()
  },

  methods: {
    getSession () {
      const loadingOverlay = new LoadingOverlay()
      loadingOverlay.start()

      this.sessionStatus = this.$config.status.LOADING

      api.session
        .getSingle(this.id)
        .then(response => {
          this.session = response
          this.sessionStatus = this.$config.status.SUCCESS
        })
        .catch(error => {
          this.$notify.error({
            title: 'Fehler',
            message: error.response.status === 404
              ? 'Diese Sitzung konnte leider nicht gefunden werden.'
              : 'Diese Sitzung konnte leider nicht geladen werden.'
          })

          this.sessionStatus = this.$config.status.ERROR
          this.$router.replace({ name: 'coaching-list' })
        })
        .finally(() => {
          loadingOverlay.stop()
        })
    },
    accept () {
      if (!window.confirm('Möchten Sie diese Einladung wirklich annehmen?')) {
        return
      }

      this.acceptStatus = this.$config.status.LOADING

      api.session
        .accept(this.id)
        .then(() => {
          this.$notify.success({
            title: 'Einladung angenommen',
            message: 'Die Einladung wurde erfolgreich angenommen.'
          })

          this.getSession()
          this.acceptStatus = this.$config.status.SUCCESS
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Die Einladung konnte nicht angenommen werden.'
          })

          this.acceptStatus = this.$config.status.ERROR
        })
    },
    reject () {
      if (!window.confirm('Möchten Sie diese Einladung wirklich ablehnen?')) {
        return
      }

      this.rejectStatus = this.$config.status.LOADING

      api.session
        .reject(this.id)
        .then(() => {
          this.$notify.success({
            title: 'Einladung abgelehnt',
            message: 'Die Einladung wurde erfolgreich abgelehnt.'
          })

          this.getSession()
          this.rejectStatus = this.$config.status.SUCCESS
        })
        .catch(() => {
          this.$notify.error({
            title: 'Fehler',
            message: 'Die Einladung konnte nicht abgelehnt werden.'
          })

          this.rejectStatus = this.$config.status.ERROR
        })
    }
  }
}
</script>
